import { Route } from '@angular/router';

export const customAttributeRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/custom-attribute-list.component').then(
        (m) => m.CustomAttributeListComponent
      ),
  },
  {
    path: 'add',
    loadComponent: () =>
      import('./detail/custom-attribute-detail.component').then(
        (m) => m.CustomAttributeDetailComponent
      ),
  },
  {
    path: 'edit/:customAttributeId',
    loadComponent: () =>
      import('./detail/custom-attribute-detail.component').then(
        (m) => m.CustomAttributeDetailComponent
      ),
  },
];
